module.exports = __webpack_public_path__ + "img/home2.58afe77d.svg";